import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../utils/cn';

const statusStyles = {
  new: 'bg-blue-100 text-blue-700',
  in_progress: 'bg-yellow-100 text-yellow-700',
  waiting_customer: 'bg-purple-100 text-purple-700',
  info_requested: 'bg-indigo-100 text-indigo-700',
  resolved: 'bg-green-100 text-green-700',
  escalated: 'bg-red-100 text-red-700',
  available: 'bg-green-100 text-green-700',
  issued: 'bg-blue-100 text-blue-700',
  blocked: 'bg-red-100 text-red-700',
};

export default function StatusBadge({ status, className }) {
  const { t } = useTranslation();
  const label = t(`status.${status}`, { defaultValue: status?.replace(/_/g, ' ') });
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        statusStyles[status] || 'bg-gray-100 text-gray-700',
        className
      )}
    >
      {label}
    </span>
  );
}
